import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreateCustomer from "../../../components/Modal/Admin/ManageCustomer/CreateCustomer";
import CreateUploadCustomer from "../../../components/Modal/Admin/ManageCustomer/CreateUploadCustomer";
import EditCustomer from "../../../components/Modal/Admin/ManageCustomer/EditCustomer";
import CreateCompanyDetail from "../../../components/Modal/Admin/ManageCustomer/CreateCompanyDetail";
import ViewCustomer from "../../../components/Modal/Admin/ManageCustomer/ViewCustomer";
import ApproveCustomer from "../../../components/Modal/Admin/ManageCustomer/ApproveCustomer";
import DisapproveCustomer from "../../../components/Modal/Admin/ManageCustomer/DisapproveCustomer";
import axiosInstance from "../../../hooks/axiosInstance";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";
import '../../../components/Modal/Admin/ManageCustomer/Style.css';

export default function ManageCustomer() {
  const MySwal = withReactContent(Swal);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showCompanyDetail, setShowCompanyDetail] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [viewCustomers, setViewCustomers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [editUserDetails, setEditUserDetails] = useState(null);
  const [editCustomerID, setCustomerID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showApprove, setShowApprove] = useState(false);
  const [showDisapprove, setShowDisapprove] = useState(false);
  const [approveCustomerId, setApproveCustomerId] = useState(null);
  const [disapproveCustomerId, setDisapproveCustomerId] = useState(null);
  const [isApproveAction, setIsApproveAction] = useState(true);

  const handleShow = () => setShow(true);
  const handleShowUpload = () => setShowUpload(true);

  const storedPermissions = localStorage.getItem("userPermissions");
  // const userDataString = localStorage.getItem("userData");
  // let userTypeId = null;

  // if (userDataString) {
  //   const userData = JSON.parse(userDataString);
  //   userTypeId = userData.user.user_type_id;

  // } else {
  //   console.log("No user data found");
  // }
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };

  // Download template
  const downloadTemplate = async () => {
    try {
      const response = await axiosInstance.get('/user/customer/download_customer_template', {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Use the filename from Laravel or default
      link.setAttribute('download', 'customer_upload_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading template', error);
    }
  };



  useEffect(() => {
    const fetchCustomers = async () => {
      setLoading(true);

      try {
        const response = await axiosInstance.get(
          `/user/customer/fetch_customer`,
          {
            params: {
              page,
              filter: searchQuery,
            },
          }
        );

        setCustomers(response.data.data.customer.data || []);
        setPagination(response.data.data.customer);
      } catch (error) {
        toast.error("Error fetching users:", error);
      }
      finally {
        setLoading(false); // Hide loader after fetching
      }
    };

    fetchCustomers();
  }, [page, searchQuery, refreshKey]);

  const handleShowView = (customer) => {
    setViewCustomers(customer);
    setShowView(true);
  };

  const handleShowEdit = (user) => {
    setEditUserDetails(user);
    setShowEdit(true);
  };
  const handleShowCustomerCompany = async (customerId) => {
    setCustomerID(customerId);
    setShowCompanyDetail(true);
  };

  const handleDeleteCustomer = async (customerId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.post(
          `/user/customer/remove-customer/${customerId}`
        );
        handleRefresh();
        handleClose();
        toast.success("Customer removed successfully!");
      } catch (error) {
        toast("Error deleting customer:", error);
      }
    }
  };

  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handleFilterChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  const handleShowApprove = (customerId, isApprove = true) => {
    if (isApprove) {
      setApproveCustomerId(customerId);
      setIsApproveAction(true);
      setShowApprove(true);
    } else {
      setDisapproveCustomerId(customerId);
      setIsApproveAction(false);
      setShowDisapprove(true);
    }
  };

  const handleClose = () => {
    setShow(false);
    setShowUpload(false);
    setShowEdit(false);
    setShowCompanyDetail(false);
    setShowView(false);
    setShowApprove(false);
    setShowDisapprove(false);
    // setChangeImage(false);
  };

  const handleApproveCustomer = async (customerId, isApprove = true) => {
    handleShowApprove(customerId, isApprove);
  };

  const toggleCreditApproval = async (id, status = 'active') => {
    try {
      const response = await axiosInstance.post(`/user/customer/approve_status/${id}`, {
        status: status
      });
      toast.success(response.data.message);
      handleRefresh(); // Refresh to update the credit list
    } catch (error) {
      console.error("Error toggling credit status:", error);
      toast.error("Failed to update credit status.");
    }
  };


  const downloadUploadedCustomers = async () => {
    try {
      const response = await axiosInstance.get(
        "/user/customer/download_uploaded_customers",
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "uploaded_customers.xlsx");

      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Download started");
    } catch (error) {
      console.error(error);
      toast.error("Failed to download uploaded customers");
    }
  };


  useEffect(() => { }, [refreshKey]);

  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Manage Customer
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#c4281c" }}
                >
                  Manage Customer
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}
      {loading && !searchQuery ? ( // Only show loader for general data fetching
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <Oval
            height={80}
            width={80}
            color="#FF0200"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      ) : (
        <div className="row" id="contactList">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex align-items-center border-0">
                <h5
                  className="card-title mb-0 flex-grow-1"
                  style={{ color: "#c4281b" }}
                >
                  Manage Customer
                </h5>
              </div>
              <div className="card-body border border-dashed border-end-0 border-start-0">
                <div className="d-flex justify-content-end mb-2">
                  {/* <div className="col-xl-8 col-md-1"></div> */}
                  {hasPermission("add_customer") && (
                    <div className="col-xl-2 col-md-4" style={{ marginRight: "5px" }}>
                      <div>
                        <button
                          className="vehicle-button btn btn-primary"
                          style={{
                            backgroundColor: "#c4281b",
                            color: "#fff",
                            border: "none",
                          }}
                          onClick={handleShow}
                        >
                          <i className="mdi mdi-plus-circle-outline"></i>Add New
                          Customer
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="col-xl-2 col-md-4">
                    <button
                      className="vehicle-button btn btn-primary"
                      // style={{ backgroundColor: "#c4281b", color: "#fff" }}
                      onClick={downloadTemplate}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> Download
                      template
                    </button>
                  </div>

                  <div className="col-xl-2 col-md-4">
                    <button
                      className="vehicle-button btn btn-primary"
                      // style={{ backgroundColor: "#c4281b", color: "#fff" }}
                      onClick={handleShowUpload}
                    >
                      <i className="mdi mdi-plus-circle-outline"></i> Upload
                      Customers
                    </button>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="search-box">
                    <input
                      type="text"
                      className="form-control search"
                      placeholder="Search to customer..."
                      value={searchQuery}
                      onChange={handleFilterChange}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="vehicle-button btn btn-success"
                    onClick={downloadUploadedCustomers}
                  >
                    <i className="mdi mdi-download"></i> Download Uploaded Customers
                  </button>
                </div> <br />
              <div className="card-body">
                
                <div className="table-responsive table-card">
                  <table
                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                    id="customerTable"
                  >
                    <thead className="table-light text-muted">
                      <tr>
                        <th>#</th>
                        <th
                        >
                          Customer Name
                        </th>
                        <th data-sort="type">
                          Email
                        </th>
                        <th>
                          Phone Number
                        </th>
                        <th>
                          State
                        </th>
                        <th>
                          City
                        </th>
                        <th>
                          Area
                        </th>
                        <th>
                          Customer Code
                        </th>
                        <th>
                          Status
                        </th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    {/* <!--end thead--> */}
                    <tbody className="list form-check-all">
                      {customers.map((customer, index) => (
                        <tr key={customer.id}>
                          <td>{index + 1}</td>
                          <td>
                            {" "}
                            {customer.first_name}
                            {/* {customer.last_name} */}
                          </td>
                          <td>{customer.email}</td>
                          <td> {customer.phone}</td>
                          <td> {customer.state}</td>
                          <td> {customer.city}</td>
                          <td> {customer.area}</td>
                          <td> {customer.customer_code}</td>
                          <td className="status">
                            {customer.status === "active" ? (
                              <span className="badge bg-success">Approve</span>
                            ) : customer.status === "inactive" ? (
                              <span className="badge bg-danger">Disapprove</span>
                            ) : null}
                          </td>

                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="mdi mdi-apps"></i>
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => handleShowView(customer)}
                                  >
                                    <i className="ri-eye-fill text-muted me-2 align-bottom"></i>
                                    View Customer
                                  </Link>
                                </li>
                                {hasPermission("add_customer") && (
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() => handleShowEdit(customer)}
                                    >
                                      <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                      Edit
                                    </Link>
                                  </li>
                                )}
                                {hasPermission("add_customer") && (
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleShowCustomerCompany(
                                          customer.customer_id
                                        )
                                      }
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-2 text-success"></i>
                                      Add Customer Company
                                    </Link>
                                  </li>
                                )}
                                {hasPermission("delete_customer") && (
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDeleteCustomer(customer.customer_id)
                                      }
                                    >
                                      <i className="mdi mdi-trash-can-outline me-2 text-danger"></i>
                                      Delete Customer
                                    </Link>
                                  </li>
                                )}
                                {hasPermission("approve_customer") && (
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() => handleApproveCustomer(customer.customer_id, customer.status !== 'active')}
                                      style={{ fontSize: "15px" }}
                                    >
                                      <i className={`mdi ${customer.status === 'active' ? 'mdi-cancel' : 'mdi-check-circle'} me-2`}></i>
                                      {customer.status === 'active' ? 'Disapprove' : 'Approve'}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* <!--end table--> */}
                  <div className="d-flex mt-5 mb-5 flex-wrap">
                    <div className="pagination-wrap hstack gap-2 mx-auto">
                      <ul className="pagination listjs-pagination mb-0">
                        {(pagination.links || []).map((link, index) => {
                          const pageNumber = link.url
                            ? new URL(link.url).searchParams.get("page")
                            : null;

                          return (
                            <li
                              key={index}
                              className={`page-item ${link.active ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  pageNumber &&
                                  handlePageChange(Number(pageNumber))
                                }
                                dangerouslySetInnerHTML={{ __html: link.label }}
                              ></button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      )}
      <CreateCustomer
        show={show}
        closeModal={handleClose}
        refreshPage={handleRefresh}
      />

      <CreateUploadCustomer
        showUpload={showUpload}
        closeModal={handleClose}
        refreshPage={handleRefresh}
      />
      <EditCustomer
        showEdit={showEdit}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        userDetails={editUserDetails}
      />
      <ViewCustomer
        showView={showView}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        customer={viewCustomers}
      />
      <CreateCompanyDetail
        showCompanyDetail={showCompanyDetail}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        customerId={editCustomerID}
      />
      <ApproveCustomer
        show={showApprove}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        customerId={approveCustomerId}
      />

      <DisapproveCustomer
        show={showDisapprove}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        customerId={disapproveCustomerId}
      />
    </>
  );
}
